export const NAME = 'FlightAlerts';
